/**
 * Centralized Endpoint Configuration
 *
 * All endpoints are proxy-relative paths routed through the server-side proxy
 * at /api/proxy/{path}. The proxy injects the Authorization header server-side,
 * so tokens never reach the browser.
 */

/**
 * Get endpoint URL for server-side proxy
 * @param {string} key - Endpoint key
 * @returns {string} - Proxy-relative endpoint path
 * @throws {Error} - If endpoint key is unknown
 */
export function getEndpoint(key) {
    const endpoints = {
        chatStream: '/api/proxy/v4/verticals/daisy/qa/stream',
        chatHistory: '/api/proxy/v4/ai/chat-history',
        chatFeedback: '/api/proxy/v4/ai/chat/feedback',
        addressLookup: '/api/proxy/v4/geo/location/lookup',
        addressCheck: '/api/proxy/v4/geo/property/report',
        propertyInfo: '/api/proxy/v4/geo/property/report',
        anonBusinessRequest: '/api/proxy/v4/workflows/business-requests/anonymous',
        sendEmail: '/api/proxy/v4/verticals/daisy/feedback/email',
        systemAlerts: '/api/proxy/v4/realtime/alerts'
    };

    if (!(key in endpoints)) {
        throw new Error(`[endpoints] Unknown endpoint key: ${key}`);
    }

    return endpoints[key];
}
